module.exports = __webpack_public_path__ + "img/horizontal_4_5_r_pp2_6000.761fa50d.png";